function normalizeKey(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

export function findCatalogProduct(catalog, item) {
  if (!item || !Array.isArray(catalog) || !catalog.length) return null;
  const name = normalizeKey(item.name || item.nomeProdotto);
  const code = String(item.codice || item.code || '').trim().toLowerCase();

  if (code) {
    const byCode = catalog.find((product) => String(product.codice || '').trim().toLowerCase() === code);
    if (byCode) return byCode;
  }

  if (!name) return null;

  const exact = catalog.find((product) => normalizeKey(product.nomeProdotto) === name);
  if (exact) return exact;

  return (
    catalog.find((product) => {
      const catalogName = normalizeKey(product.nomeProdotto);
      return catalogName && (catalogName.includes(name) || name.includes(catalogName));
    }) || null
  );
}

export function mergeProductWithCatalog(item, catalog) {
  const match = findCatalogProduct(catalog, item);
  return {
    ...item,
    name: item?.name || match?.nomeProdotto || '',
    description: item?.description || match?.descrizione || '',
    'caratteristiche tecniche': item?.['caratteristiche tecniche'] || match?.['caratteristiche tecniche'] || '',
    'link puro': match?.urlPagina || item?.['link puro'] || item?.pageUrl || item?.urlPagina || '',
    url3Dviewer: match?.url3Dviewer || item?.url3Dviewer || '',
    urlImage: match?.urlImage || item?.urlImage || '',
    urlVideo: match?.urlVideo || item?.urlVideo || '',
  };
}

export function productHasMedia(product) {
  return Boolean(product?.urlImage || product?.urlVideo || product?.url3Dviewer);
}
